import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import WebhookSettingLayer from "../components/WebhookSettingLayer";


const WebhookSetting = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Webhook Access" />

        {/* WebhookSettingLayer */}
        <WebhookSettingLayer />


      </MasterLayout>
    </>
  );
};

export default WebhookSetting;
